import { ErrorKey } from '../app-active-error/ErrorKey';
import { Auth } from '../auth/authUtils';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { setHasRefreshedNewPortalAuth } from '../store/app/action-creators';
import { AppActionTypes } from '../store/app/action-types';
import { setError } from '../store/error/action-creators';
const LOG = Logger.getLogger('handleLoginNewPortalResponse');
export const handleLoginNewPortalSuccess = dispatch => {
  return dispatch(Auth.init()).then(() => {
    dispatch(setHasRefreshedNewPortalAuth(true));
    dispatch({
      type: AppActionTypes.SignupEnded
    });
  }).catch(error => LOG.error('Auth.init error', {
    extra: getSentryExtra(error)
  }));
};
export const handleLoginNewPortalFailure = (error, dispatch) => {
  const {
    status
  } = error;
  LOG.warn(`attemptUserLogin-cookie: ${status || 'no-status'}`, {
    extra: getSentryExtra(error)
  });
  dispatch(setError(ErrorKey.LoginFailed, error));
};